export default {
    SAVE: "Сохранить"
};
